import {
  getActiveUser,
  navigate,
  sendGetRequest,
  purpose,
  scheduled,
  UserRoles,
  formatDate,
  sendPatchRequest,
  sendDeleteRequest,
  watchLiveData,
  sendPostRequest,
  allowedOperations,
  downloadContents,
  showSnack,
  capitalizeFirstLetter,
} from "../utils/utils";
import {
  ButtonGroup,
  Button,
  Icon,
  Box,
  Tooltip,
  DialogContent,
  Dialog,
  DialogActions,
  DialogTitle,
  TextField,
  Autocomplete,
  Checkbox,
  Grid,
  CircularProgress,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormControlLabel,
  Switch,
  Typography,
  Chip,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Table,
  Paper,
  TableBody,
  IconButton,
} from "@mui/material";
import DataListWithSearch from "./component/@list/list-search";
import { useState, useEffect, useRef } from "react";
import AppRoutes from "../routing/routes";
import { coreStyles } from "../theme/style";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useSelector } from "react-redux";
import EasyTextEdit from "./component/text-edit";
import { Dropzone, FileMosaic } from "@files-ui/react";

const fileSourceRef = { title: "", label: "" };

const getTableHead = () => {
  return [
    { id: "createdAt", label: "Created On", alignRight: false },
    { id: "code", label: "Code", alignRight: false },
    { id: "title", label: "Title", alignRight: false },
    { id: "section", label: "Section", alignRight: false },
    { id: "category", label: "Type", alignRight: false },
    { id: "language", label: "Language", alignRight: false },
    { id: "subject", label: "Subject", alignRight: false },
    { id: "premium", label: "Premium", alignRight: false },
    { id: "forTheApp", label: "App", alignRight: false, align: "center" },
    { id: "forYoutube", label: "Youtube", alignRight: false },
  ];
};

const ContentList = () => {
  const loggedUser = getActiveUser();
  const [dataList, setDataList] = useState([]);
  const [loading, onLoading] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [filterKey, setFilterkey] = useState("title");
  const [showFileSourceTypeDialog, setShowFileSourceTypeDialog] = useState(false);
  const [fileSource, setFileSource] = useState(fileSourceRef);
  const [importDialogOpen, setImportDialogOpen] = useState(false);
  var [files, setFiles] = useState([]);
  const [logoRef, setLogoRef] = useState({
    uuid: "none",
    withIntroOutro: false,
  });
  const [youtubeProps, setYoutubeProps] = useState({
    channel: null,
    fade: null,
  });
  const [moveProps, setMoveProps] = useState({
    isVideo: false,
    type: null,
    section: null,
  });
  const [continents, setContinents] = useState([]);
  const [tvShows, setTvShows] = useState([]);
  const [premium, setPremium] = useState([]);
  const [selectedToPremier, setSelectedToPremier] = useState([]);
  const [selectedToYoutube, setSelectedToYoutube] = useState([]);
  const [selectedToStream, setSelectedToStream] = useState([]);
  const [qualities, setQualities] = useState([]);
  const [selectedToBrand, setSelectedToBrand] = useState([]);
  const [selectedToMove, setSelectedToMove] = useState([]);
  const [selectedToLanguage, setSelectedToLanguage] = useState([]);
  const [selectedToSubject, setSelectedToSubject] = useState([]);
  const [selectedToSourceTypes, setSelectedToSourceTypes] = useState([]);
  const [selectedToCode, setSelectedToCode] = useState([]);
  const [fileSourceTypes, setFileSourceType] = useState([]);
  const [deletedfileSourceTypes, setDeletedfileSourceTypes] = useState([]);
  var [sections, setSections] = useState([]);
  var [language, setLanguage] = useState(null);
  var [subject, setSubject] = useState(null);
  var [code, setCode] = useState(null);
  var [categories, setCategories] = useState([]);
  const appStyle = coreStyles();
  const { queue } = useSelector((state) => state.queue);
  let requestTimeout = useRef(null);
  const { canEdit, canDelete, canCreate } = allowedOperations();

  const triggerContentExport = (label) => {
    setTimeout(() => onLoading(false), 5000);
    onLoading(true);
    downloadContents(label);
  };

  const onValueChange = (value, tag) => {
    setFileSource({ ...fileSource, [tag]: value });
  };

  const exportImportOptions = [
    canEdit
      ? {
          icon: "list_alt",
          value: "all",
          label: "All contents",
          onClick: () => triggerContentExport("all"),
        }
      : null,
    canEdit
      ? {
          icon: "closed_caption_off",
          value: "with-code",
          label: "Completed contents",
          onClick: () => triggerContentExport("with-code"),
        }
      : null,
    canEdit
      ? {
          icon: "closed_caption_disabled",
          value: "without-code",
          label: "Incomplete contents",
          onClick: () => triggerContentExport("without-code"),
        }
      : null,
    /* canEdit
      ? {
          icon: "download",
          value: "import",
          label: "Update from Excel",
          onClick: () => setImportDialogOpen(true),
        }
      : null, */
  ];

  const userOptions = [
    canDelete
      ? {
          icon: "delete",
          value: "delete",
          label: "Delete",
          onClick: (value, selected) => {
            onLoading(true);
            Promise.all(
              selected.map((uuid) => sendDeleteRequest("contents", uuid)),
            ).then((_) => executeFetch(true));
          },
        }
      : null,
    canEdit
      ? {
          icon: "paid",
          value: "premium",
          label: "Premium",
          onClick: (value, selected) => setSelectedToPremier(selected),
        }
      : null,
    canEdit
      ? {
          icon: "paid",
          value: "free",
          label: "Free content",
          onClick: (value, selected) =>
            sendPatchRequest(
              `contents/app-content-premium`,
              { contents: selected, premium: [] },
              (loading) => onLoading(true),
              (data) => {
                executeFetch();
                onLoading(false);
              },
            ),
        }
      : null,
    canEdit
      ? {
          icon: "branding_watermark",
          value: "brand",
          label: "Brand Video",
          onClick: (value, selected) => {
            const _selected = dataList
              .filter(
                (data) => selected.includes(data.uuid) && data.isVideo === true,
              )
              .map((data) => data.uuid);
            setSelectedToBrand(_selected);
          },
        }
      : null,
    canEdit
      ? {
          icon: "stream",
          value: "stream",
          label: "Generate streams",
          onClick: (value, selected) => {
            const contents = dataList
              .filter((data) => selected.includes(data.uuid))
              .map((data) => data.uuid);
            setSelectedToStream(contents);
          },
        }
      : null,
    canEdit
      ? {
          icon: "edit",
          value: "edit",
          label: "Edit",
          onClick: (_value, selected) => startEdit(selected),
        }
      : null,
    canEdit
      ? {
          icon: "output",
          value: "move",
          label: "Move content",
          onClick: (_value, selected) => setSelectedToMove(selected),
        }
      : null,

    canEdit
      ? {
          icon: "language",
          value: "language",
          label: "Language",
          onClick: (_value, selected) => setSelectedToLanguage(selected),
        }
      : null,

    canEdit
      ? {
          icon: "subject",
          value: "subject",
          label: "Subject",
          onClick: (_value, selected) => setSelectedToSubject(selected),
        }
      : null,
      canEdit
      ? {
          icon: "source",
          value: "source",
          label: "Source Type",
          onClick: (_value, selected) => setSelectedToSourceTypes(selected),
        }
      : null,
    /* canEdit
      ? {
          icon: "abc",
          value: "code",
          label: "Code",
          onClick: (_value, selected) => setSelectedToCode(selected),
        }
      : null, */
    canEdit
      ? {
          icon: "smart_display",
          value: "preview",
          label: "Preview",
          onClick: (_value, selected) => {
            const content = dataList.filter((data) =>
              selected.includes(data.uuid),
            )[0];
            handleClickLink(
              content.uuid,
              content.urls.stream ? "stream" : "play",
            );
          },
        }
      : null,
    canEdit
      ? {
          icon: "apps",
          value: "app_activate",
          label: "Publish to apps",
          onClick: (_value, selected) =>
            executeUpdate("app_activate", selected),
        }
      : null,
    canEdit
      ? {
          icon: "apps_outage",
          value: "app_deactivate",
          label: "Remove from apps",
          onClick: (_value, selected) =>
            executeUpdate("app_deactivate", selected),
        }
      : null,
    canEdit
      ? {
          icon: "playlist_add",
          value: "youtube_activate",
          label: "Publish to Youtube",
          onClick: (_value, selected) => {
            const uuids = dataList
              .filter((data) => selected.includes(data.uuid))
              .filter(
                (data) =>
                  (data.forYoutube && !data.forYoutube.uploaded) ||
                  !data.forYoutube,
              )
              .map((data) => data.uuid);
            if (uuids.length === 0) return;
            setSelectedToYoutube(selected);
          },
        }
      : null,

    canEdit
      ? {
          icon: "subtitles",
          value: "subtitle",
          label: "Manage Subtitle",
          onClick: (_value, selected) => {
            navigate(
              `${AppRoutes.contents}/${
                AppRoutes.subtitles
              }?contentId=${selected.join()}`,
              true,
            );
          },
        }
      : null,
  ].filter(Boolean);

  const startEdit = (uuid) =>
    navigate(
      `${AppRoutes.contents}/${AppRoutes.content}${
        uuid ? `?uuid=${uuid}` : ""
      }`,
      true,
    );

  const resetPremiumProps = (uuid) => {
    setSelectedToPremier([]);
    setPremium([]);
  };

  const resetStreamProps = (uuid) => {
    setSelectedToStream([]);
    setQualities([]);
  };

  const resetLanguage = () => {
    setLanguage(null);
    setSelectedToLanguage([]);
  };

  const resetSubject = () => {
    setSubject(null);
    setSelectedToSubject([]);
  };

  const resetSourceTypes = () => {
    setFileSource(fileSourceRef);
    setSelectedToSourceTypes([]);
  }

  const resetCode = () => {
    setCode(null);
    setSelectedToCode([]);
  };

  const hideImportDialog = () => {
    setFiles([]);
    setImportDialogOpen(false);
  };

  const resetMoveProps = (uuid) => {
    setSelectedToMove([]);
    setMoveProps({ isVideo: false, type: null, section: null });
  };

  const resetBrandProps = (uuid) => {
    setSelectedToBrand([]);
    setLogoRef("none");
  };

  const resetYoutubeProps = (uuid) => {
    setSelectedToYoutube([]);
    setLogoRef("none");
  };

  const btnGroupOptions = [
    { label: "Content Types", destination: `${AppRoutes.contents}/types` },
    { label: "Content File Sources", destination: `fileSourceTypes` },
    {
      label: "Content Sections",
      destination: `${AppRoutes.contents}/sections`,
    },
    { label: "Content Shows", destination: `${AppRoutes.shows}` },
    {
      label: "Languages",
      destination: `${AppRoutes.contents}/${AppRoutes.languages}`,
    },
    {
      label: "Subjects",
      destination: `${AppRoutes.contents}/${AppRoutes.subjects}`,
    },
    { label: "Tasks", destination: `${AppRoutes.tasks}` },
  ];

  const filterOptions = [
    { value: "title", label: "Title", onClick: setFilterkey },
    { value: "code", label: "Code", onClick: setFilterkey },
    { value: "subject", label: "Subject", onClick: setFilterkey },
    { value: "category", label: "Category", onClick: setFilterkey },
    { value: "section", label: "Section", onClick: setFilterkey },
    { value: "language", label: "Language", onClick: setFilterkey },
  ];

  const saveFileSourceChanges = () => {
    if (deletedfileSourceTypes.length) {
      onLoading(true);
      Promise.all(
        deletedfileSourceTypes.map((uuid) =>
          sendDeleteRequest("file-sources", uuid),
        ),
      ).then((_) => {
        setDeletedfileSourceTypes([]);
        fetchfileSourceTypes();
        onLoading(false);
        setShowFileSourceTypeDialog(false);
      });
    }
  };

  const fetchfileSourceTypes = (load = false) => {
    sendGetRequest("file-sources",
      (loading) => load ? onLoading(loading): null,
      (data) => setFileSourceType(data),
    );
  };
  const executeFetch = (refresh = false) => {
    if (!refresh) onLoading(true);
    Promise.all([
      sendGetRequest(
        "contents",
        (_) => {},
        (data) =>
          setDataList(
            data.map((content) => {
              const category = content.section
                ? content.section.category.name
                : "N/A";
              return {
                uuid: content.uuid,
                forYoutube: content.forYoutube,
                forTheApp: content.forTheApp,
                title: content.title,
                code: content.code,
                url: content.url,
                thumbnail: content.thumbnail,
                category,
                subject: content.subject ? content.subject.name : "N/A",
                section: content.section ? content.section.title : "N/A",
                createdAt:
                  typeof content.createdAt === "number"
                    ? content.createdAt
                    : new Date().getTime(),
                premium:
                  content.premium && content.premium.length > 0
                    ? content.premium
                    : null,
                fromAge: content.fromAge,
                toAge: content.toAge,
                streamUrl: content.streamUrl,
                scheduledAt: content.scheduledAt,
                language:
                  (content.contentLanguage
                    ? content.contentLanguage.name
                    : content.language) ?? "N/A",
                isVideo: content.type === "video",
                urls: content.urls,
                hasSubtitles: content.subtitles && content.subtitles.length > 0,
              };
            }),
          ),
      ),
      sendGetRequest(
        `contents/continents`,
        (_) => null,
        (data) => setContinents(data),
      ),
      sendGetRequest(
        `channels`,
        (_) => null,
        (data) => setTvShows(data),
      ),
      sendGetRequest(
        "categories",
        (_) => null,
        (data) => {
          const types = data.filter((type) => type.name !== "Home");
          types.sort((prev, next) => prev.order - next.order);
          setCategories(types);
        },
      ),
      sendGetRequest(
        "sections",
        (_) => null,
        (data) => setSections(data),
      ),
      sendGetRequest(
        `languages`,
        (_) => null,
        (data) => setLanguages(data),
      ),
      sendGetRequest(
        `subjects`,
        (_) => null,
        (data) => setSubjects(data),
      ),
      fetchfileSourceTypes(false),
    ]).then(() => onLoading(false));
  };

  useEffect(
    () => executeFetch(),
    // eslint-disable-next-line
    [],
  );

  useEffect(() => {
    if (queue)
      watchLiveData(queue, "contents", (data) => {
        if (requestTimeout) clearTimeout(requestTimeout.current);
        requestTimeout.current = setTimeout(() => executeFetch(true), 4000);
      });
    // eslint-disable-next-line
  }, [queue]);

  const handleClickLink = (uuid, type) => {
    navigate(
      `${AppRoutes.tasks}/${AppRoutes.plays}?uuid=${uuid}&type=${type}&source=${AppRoutes.contents}`,
      true,
    );
  };

  const executeUpdate = (tag, ids) => {
    let data = {};
    let uuids = [];
    if (`${tag}`.startsWith("app_")) {
      if (tag === "app_activate") {
        uuids = dataList
          .filter((data) => ids.includes(data.uuid))
          .filter((data) => !data.forTheApp)
          .map((data) => data.uuid);
      } else {
        uuids = dataList
          .filter((data) => ids.includes(data.uuid))
          .filter((data) => data.forTheApp)
          .map((data) => data.uuid);
      }
      data = { contents: uuids, forTheApp: tag === "app_activate" };
      if (uuids.length > 0) {
        onLoading(true);
        sendPatchRequest(`contents/app-content-activation`, data).then((_) => {
          executeFetch();
          onLoading(false);
        });
      }
    }
  };

  const optionsToShow = () => {
    const showWithoutCode = dataList.filter((data) => !data.code).length > 0;
    return ["all", ...(showWithoutCode ? ["without-code", "with-code"] : [])];
  };

  const createUpdateFileSource = () => {
    onLoading(true);
    if (fileSource.uuid) {
      const { uuid, ...rest } = fileSource;
      sendPatchRequest( `file-sources/${uuid}`,{ ...rest },
        (loading) => onLoading(loading),
        (_) => {
          setFileSource(fileSourceRef);
          fetchfileSourceTypes();
        },
      );
      return;
    }
    sendPostRequest("file-sources",{ ...fileSource },
      (loading) => onLoading(loading),
      (_) => {
        setFileSource(fileSourceRef);
        fetchfileSourceTypes();
      },
    );
  };

  return (
    <div>
      <DataListWithSearch
        sectionTitle="Contents"
        exportImportOptions={exportImportOptions.filter(
          (option) => option !== null && optionsToShow().includes(option.value),
        )}
        createNewElement={
          canCreate ? (
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <ButtonGroup size="large" aria-label="large button group">
                {btnGroupOptions.map((btn) => {
                  return (
                    <Button
                      key={btn.destination}
                      onClick={() =>
                        btn.destination === "fileSourceTypes"
                          ? setShowFileSourceTypeDialog(true)
                          : navigate(`${btn.destination}`, true)
                      }
                    >
                      {btn.label}
                    </Button>
                  );
                })}
              </ButtonGroup>
              <Button
                variant="contained"
                onClick={() => startEdit()}
                className={appStyle.actionButonCustom}
                startIcon={
                  <Icon children={"add"} className={appStyle.actionButonIcon} />
                }
              >
                {"Add content"}
              </Button>
            </Box>
          ) : null
        }
        data={dataList}
        primaryKey="uuid"
        filterColumn={filterKey}
        emptyIcon="toc"
        avatarKey="uuid"
        loading={loading}
        headers={getTableHead()}
        rowData={(data) => {
          const label = purpose(data.premium != null);
          const appStatus = purpose(data.forTheApp);
          const _scheduled = scheduled();
          const hideYoutube =
            data.isVideo && data.forYoutube && data.forYoutube.uploaded;
          const uploaded = data.forYoutube && data.forYoutube.uploaded;
          const _entries = [
            {
              value: formatDate(data.createdAt, "MMM DD, YYYY hh:mmA"),
              width: 150,
              align: "left",
            },
            { value: data.code || "N/A", width: 70 },
            { value: data.title, width: 180 },
            { value: data.section, width: 110 },
            { value: data.category, width: 50 },
            { value: data.language, width: 30, align: "center" },
            { value: data.subject, width: 50, align: "center" },
            {
              ...(data.premium !== null
                ? {
                    value: (
                      <Tooltip
                        title={data.premium.map((pre) => pre.name).join(", ")}
                        arrow
                      >
                        <Icon
                          children={label.value === "YES" ? "check" : "close"}
                          color={label.color}
                        />
                      </Tooltip>
                    ),
                    align: "center",
                    width: 20,
                  }
                : {
                    value: (
                      <Icon
                        children={label.value === "YES" ? "check" : "close"}
                        color={label.color}
                      />
                    ),
                    align: "center",
                    width: 20,
                  }),
            },
            {
              ...(data.scheduledAt
                ? {
                    value: (
                      <Tooltip
                        title={formatDate(
                          data.scheduledAt,
                          "MMM DD, YYYY hh:mm A",
                        )}
                        arrow
                      >
                        <Icon
                          children="query_builder"
                          color={_scheduled.color}
                        />
                      </Tooltip>
                    ),
                    align: "center",
                    width: 20,
                  }
                : {
                    value: (
                      <Icon
                        children={appStatus.value === "YES" ? "check" : "close"}
                        color={appStatus.color}
                      />
                    ),
                  }),
              align: "center",
              width: 20,
            },
            {
              value: (
                <Icon
                  children={uploaded ? "check" : "close"}
                  color={uploaded ? "success" : "error"}
                />
              ),
              align: "center",
              width: 20,
            },
            {
              value: (
                <Icon
                  children={data.streamUrl ? "stream" : "play_circle_filled"}
                  color={data.streamUrl ? "error" : "primary"}
                  className={appStyle.asLink}
                  onClick={() =>
                    handleClickLink(
                      data.uuid,
                      data.streamUrl ? "stream" : "play",
                    )
                  }
                />
              ),
              align: "center",
              width: 20,
            },
            {
              value: data.isVideo ? (
                <Icon
                  children={"subtitles"}
                  color={data.hasSubtitles ? "primary" : "action"}
                  className={appStyle.asLink}
                  onClick={() =>
                    navigate(
                      `${AppRoutes.contents}/${AppRoutes.subtitles}?contentId=${data.uuid}`,
                      true,
                    )
                  }
                />
              ) : (
                "N/A"
              ),
              align: "center",
              width: 20,
            },
          ];
          return {
            exclude: [
              //data.streamUrl === null && `${data.category}`.toLocaleLowerCase() === "video" ? "" : "stream",
              data.premium === null ? "free" : "premium",
              loggedUser.role === UserRoles.editor ? "delete" : "",
              !data.forTheApp ? "app_deactivate" : "app_activate",
              data.scheduledAt ? "app_deactivate" : "",
              data.isVideo ? "" : "preview",
              !data.isVideo ? "stream" : "",
              !data.isVideo || hideYoutube ? "youtube_activate" : "",
              !data.isVideo ? "subtitle" : "",
              !data.isVideo ? "brand" : "",
            ],
            entries: _entries,
          };
        }}
        selectionOptions={userOptions.filter(
          (option) =>
            (option.value !== "edit" && option.value !== "preview") ||
            (loggedUser.role === UserRoles.editor
              ? option.value !== "delete"
              : false),
        )}
        filterOptions={filterOptions}
        optionItems={userOptions}
      />

      <Dialog
        open={selectedToPremier.length > 0}
        onClose={() => resetPremiumProps()}
        fullWidth
        maxWidth={"sm"}
      >
        <DialogTitle>
          {" "}
          Set {selectedToPremier.length} content
          {selectedToPremier.length > 1 ? "s" : ""} premium locations
        </DialogTitle>
        <DialogContent>
          <Grid container direction="column" sx={{ pt: 4 }}>
            <Autocomplete
              multiple
              id="premium"
              disableCloseOnSelect
              limitTags={10}
              value={premium.map((pre) => pre.name)}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              options={continents.map((option) => option.name)}
              renderInput={(params) => (
                <TextField {...params} label="Premium Content Locations" />
              )}
              onChange={(event, value) =>
                setPremium(
                  continents.filter((cont) => value.includes(cont.name)),
                )
              }
            />
          </Grid>
        </DialogContent>
        <DialogActions sx={{ pb: 4 }}>
          <Button onClick={() => resetPremiumProps()}>Cancel</Button>
          <Button
            disabled={premium.length === 0}
            onClick={() =>
              sendPatchRequest(
                `contents/app-content-premium`,
                { contents: selectedToPremier, premium },
                (loading) => onLoading(true),
                (data) => {
                  resetPremiumProps();
                  executeFetch();
                  onLoading(false);
                },
              )
            }
            sx={{ mr: 3, pl: 2, pr: 2 }}
          >
            {loading && <CircularProgress color="primary" />}
            {loading ? "" : "Set premium"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={selectedToBrand.length > 0}
        onClose={() => resetBrandProps()}
        fullWidth
        maxWidth={"sm"}
      >
        <DialogTitle> Select your TV show</DialogTitle>
        <DialogContent>
          <Grid container direction="column" sx={{ pt: 4 }}>
            <FormControl sx={{ minWidth: 50 }} fullWidth>
              <InputLabel id="show">Branding from</InputLabel>
              <Select
                value={logoRef.uuid}
                label="Branding from"
                labelId="show"
                id="logoRef"
                onChange={(e) =>
                  setLogoRef({ ...logoRef, uuid: e.target.value })
                }
              >
                {[{ uuid: "none", name: "No-Branding" }, ...tvShows].map(
                  (tv) => {
                    return (
                      <MenuItem value={tv.uuid} id={`tv-${tv.uuid}`}>
                        &nbsp;&nbsp;&nbsp;{tv.name}
                        <br />
                      </MenuItem>
                    );
                  },
                )}
              </Select>
            </FormControl>

            {logoRef.uuid !== "none" && (
              <FormControlLabel
                sx={{ mt: 4 }}
                labelPlacement="start"
                checked={logoRef.withIntroOutro}
                control={<Switch />}
                onChange={(event) =>
                  setLogoRef({
                    ...logoRef,
                    withIntroOutro: event.target.checked,
                  })
                }
                label={
                  <Typography variant="body1">
                    {logoRef.withIntroOutro ? "With" : "Without "} Intro/Outro
                    included &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </Typography>
                }
              />
            )}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ pb: 4 }}>
          <Button onClick={() => resetBrandProps()}>Cancel</Button>
          <Button
            disabled={logoRef.uuid === "none"}
            onClick={() => {
              sendPostRequest(
                `contents/brand-content`,
                {
                  contents: selectedToBrand,
                  logoRef: logoRef.uuid,
                  withIntroOutro: logoRef.withIntroOutro,
                },
                (loading) => onLoading(loading),
                (data) => {
                  resetBrandProps();
                  executeFetch();
                },
              );
            }}
            sx={{ mr: 3, pl: 2, pr: 2 }}
          >
            {loading && <CircularProgress color="primary" />}
            {loading ? "" : "Brand Now"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={selectedToYoutube.length > 0}
        onClose={() => resetBrandProps()}
        fullWidth
        maxWidth={"sm"}
      >
        <DialogTitle> Select channel to upload to</DialogTitle>
        <DialogContent>
          <Grid container direction="row" spacing={2} sx={{ pt: 4 }}>
            <Grid item xs={6} xl={12}>
              <FormControl sx={{ minWidth: 50 }} fullWidth>
                <InputLabel id="channel">Upload to</InputLabel>
                <Select
                  value={
                    youtubeProps.channel ? youtubeProps.channel.uuid : null
                  }
                  label="Upload to"
                  labelId="channel"
                  id="channel"
                  onChange={(e) =>
                    setYoutubeProps({
                      ...youtubeProps,
                      channel: tvShows.filter(
                        (tv) => tv.uuid === e.target.value,
                      )[0],
                    })
                  }
                >
                  {[...tvShows].map((tv) => {
                    return (
                      <MenuItem value={tv.uuid} id={`channel-${tv.uuid}`}>
                        &nbsp;&nbsp;&nbsp;{tv.name}
                        <br />
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} xl={12}>
              <FormControl sx={{ minWidth: 50 }} fullWidth>
                <InputLabel id="fades">Transition Fade</InputLabel>
                <Select
                  value={youtubeProps.fade}
                  label="Transition Fade"
                  labelId="fades"
                  id="fades"
                  onChange={(e) =>
                    setYoutubeProps({ ...youtubeProps, fade: e.target.value })
                  }
                >
                  {[true, false].map((fade) => {
                    return (
                      <MenuItem value={fade} id={fade}>
                        &nbsp;&nbsp;&nbsp;{fade ? "White fade" : "Black fade"}
                        <br />
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ pb: 4 }}>
          <Button onClick={() => resetYoutubeProps()}>Cancel</Button>
          <Button
            disabled={
              youtubeProps.channel === null || youtubeProps.fade === null
            }
            onClick={() =>
              sendPatchRequest(
                `contents/app-content-youtube`,
                { contents: selectedToYoutube, forYoutube: youtubeProps },
                (loading) => onLoading(true),
                (data) => {
                  resetYoutubeProps();
                  executeFetch();
                  onLoading(false);
                },
              )
            }
            sx={{ mr: 3, pl: 2, pr: 2 }}
          >
            {loading && <CircularProgress color="primary" />}
            {loading ? "" : "Upload Now"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={selectedToStream.length > 0}
        onClose={() => resetStreamProps()}
        fullWidth
        maxWidth={"sm"}
      >
        <DialogTitle>
          {" "}
          Generate streams for {selectedToStream.length} content
          {selectedToPremier.length > 1 ? "s" : ""}
        </DialogTitle>
        <DialogContent>
          <Grid container direction="column" sx={{ pt: 4 }}>
            <Autocomplete
              multiple
              id="qualities"
              disableCloseOnSelect
              limitTags={4}
              value={qualities}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    variant="filled"
                    label={`${option}p`}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {`${option}p - ${
                    option === "2160"
                      ? "4K"
                      : option === "1080"
                        ? "UHD"
                        : option === "720"
                          ? "HD"
                          : "SD"
                  }`}
                </li>
              )}
              options={["240", "360", "480", "720", "1080", "2160"]}
              renderInput={(params) => (
                <TextField {...params} label={`Streaming quality`} />
              )}
              onChange={(event, value) => setQualities(value)}
            />
          </Grid>
        </DialogContent>
        <DialogActions sx={{ pb: 4 }}>
          <Button onClick={() => resetStreamProps()}>Cancel</Button>
          <Button
            disabled={qualities.length === 0}
            onClick={() => {
              sendPostRequest(
                "contents/generate-streams",
                { contents: selectedToStream, streamQuality: qualities },
                (loading) => onLoading(loading),
              ).then((_) => {
                resetStreamProps();
                executeFetch();
              });
            }}
            sx={{ mr: 3, pl: 2, pr: 2 }}
          >
            {loading && <CircularProgress color="primary" />}
            {loading ? "" : "Generate Now"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={selectedToMove.length > 0}
        onClose={() => resetMoveProps()}
        fullWidth
        maxWidth={"sm"}
      >
        <DialogTitle> Move to</DialogTitle>
        <DialogContent>
          <Grid container direction="row" spacing={2} sx={{ pt: 4 }}>
            <Grid item xs={6} xl={12}>
              <FormControl sx={{ minWidth: 200 }} fullWidth>
                <InputLabel id="type-label">Content type</InputLabel>
                <Select
                  value={moveProps.type ? moveProps.type.uuid : null}
                  label="Content Type"
                  labelId="type-label"
                  id="category"
                  autoWidth
                  onChange={(e) =>
                    setMoveProps({
                      ...moveProps,
                      type: categories.filter(
                        (cat) => cat.uuid === e.target.value,
                      )[0],
                    })
                  }
                >
                  {(categories || []).map((category) => {
                    return (
                      <MenuItem value={category.uuid} id={category.uuid}>
                        &nbsp;&nbsp;&nbsp;{category.name}
                        <br />
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} xl={12}>
              <FormControl sx={{ minWidth: 200 }} fullWidth>
                <InputLabel id="section-label">Content Section</InputLabel>
                <Select
                  value={moveProps.section}
                  label="Content Section"
                  labelId="section-label"
                  id="section"
                  onChange={(e) =>
                    setMoveProps({ ...moveProps, section: e.target.value })
                  }
                >
                  {(sections || [])
                    .filter(
                      (section) =>
                        moveProps.type &&
                        section.category.uuid === moveProps.type.uuid,
                    )
                    .map((section) => {
                      return (
                        <MenuItem value={section.uuid} id={section.uuid}>
                          &nbsp;&nbsp;&nbsp;{section.title}
                          <br />
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ pb: 4 }}>
          <Button onClick={() => resetMoveProps()}>Cancel</Button>
          <Button
            disabled={moveProps.type === null || moveProps.section === null}
            onClick={() =>
              sendPatchRequest(
                `contents/move-content`,
                {
                  contents: selectedToMove,
                  section: moveProps.section,
                  type: `${moveProps.type.name}`.toLocaleLowerCase(),
                  isVideo:
                    `${moveProps.type.name}`.toLocaleLowerCase() === "video",
                },
                (loading) => onLoading(true),
                (data) => {
                  resetMoveProps();
                  executeFetch();
                  onLoading(false);
                },
              )
            }
            sx={{ mr: 3, pl: 2, pr: 2 }}
          >
            {loading && <CircularProgress color="primary" />}
            {loading ? "" : "Move Now"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={selectedToLanguage.length > 0}
        onClose={() => resetLanguage()}
        fullWidth
        maxWidth={"sm"}
      >
        <DialogTitle> Change language to</DialogTitle>
        <DialogContent>
          <Grid container direction="row" spacing={2} sx={{ pt: 4 }}>
            <Grid item xs={12} xl={12}>
              <FormControl sx={{ minWidth: 50 }} fullWidth>
                <InputLabel id="language">Content Language</InputLabel>
                <Select
                  value={language}
                  label="Content Language"
                  labelId="language"
                  id="language"
                  onChange={(e) => setLanguage(e.target.value)}
                >
                  {languages.map((language) => {
                    return (
                      <MenuItem value={language.isoCode} id={language.isoCode}>
                        &nbsp;&nbsp;&nbsp;{language.name}
                        <br />
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ pb: 4 }}>
          <Button onClick={() => resetLanguage()}>Cancel</Button>
          <Button
            disabled={language === null}
            onClick={() =>
              sendPatchRequest(
                `contents/change-language`,
                { contents: selectedToLanguage, language },
                (loading) => onLoading(true),
                (data) => {
                  resetLanguage();
                  executeFetch();
                  onLoading(false);
                },
              )
            }
            sx={{ mr: 3, pl: 2, pr: 2 }}
          >
            {loading && <CircularProgress color="primary" />}
            {loading ? "" : "Change Now"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={selectedToSubject.length > 0}
        onClose={() => resetSubject()}
        fullWidth
        maxWidth={"sm"}
      >
        <DialogTitle> Change Subject to</DialogTitle>
        <DialogContent>
          <Grid container direction="row" spacing={2} sx={{ pt: 4 }}>
            <Grid item xs={12} xl={12}>
              <FormControl sx={{ minWidth: 50 }} fullWidth>
                <InputLabel id="subject">Content Subject</InputLabel>
                <Select
                  value={subject}
                  label="Content Subject"
                  labelId="subject"
                  id="subject"
                  onChange={(e) => setSubject(e.target.value)}
                >
                  {subjects.map((subject) => {
                    return (
                      <MenuItem value={subject.uuid} id={subject.uuid}>
                        &nbsp;&nbsp;&nbsp;{subject.name}
                        <br />
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ pb: 4 }}>
          <Button onClick={() => resetSubject()}>Cancel</Button>
          <Button
            disabled={subject === null}
            onClick={() =>
              sendPatchRequest(
                `contents/change-subject`,
                { contents: selectedToSubject, subject },
                (loading) => onLoading(true),
                (data) => {
                  resetSubject();
                  executeFetch();
                  onLoading(false);
                },
              )
            }
            sx={{ mr: 3, pl: 2, pr: 2 }}
          >
            {loading && <CircularProgress color="primary" />}
            {loading ? "" : "Change Now"}
          </Button>
        </DialogActions>
      </Dialog>


 <Dialog
        open={selectedToSourceTypes.length > 0}
        onClose={() => resetSourceTypes()}
        fullWidth
        maxWidth={"sm"}
      >
        <DialogTitle> Change file source type to</DialogTitle>
        <DialogContent>
          <Grid container direction="row" spacing={2} sx={{ pt: 4 }}>
            <Grid item xs={12} xl={12}>
              <FormControl sx={{ minWidth: 50 }} fullWidth>
                <InputLabel id="subject">File Source Type</InputLabel>
                <Select
                  value={fileSource}
                  label="File Source Type"
                  labelId="fileSource"
                  id="fileSource"
                  onChange={(e) => setFileSource(e.target.value)}
                >
                  {fileSourceTypes.map((sourceType) => {
                    return (
                      <MenuItem value={sourceType.uuid} id={sourceType.uuid}>
                        &nbsp;&nbsp;&nbsp;{`${sourceType.title} (${capitalizeFirstLetter(sourceType.label)})`}
                        <br />
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ pb: 4 }}>
          <Button onClick={() => resetSourceTypes()}>Cancel</Button>
          <Button
            disabled={fileSource === null}
            onClick={() =>
              sendPatchRequest(
                `contents/change-source-type`,
                { contents: selectedToSourceTypes, fileSource },
                (loading) => onLoading(true),
                (data) => {
                  resetSourceTypes();
                  executeFetch();
                  onLoading(false);
                },
              )
            }
            sx={{ mr: 3, pl: 2, pr: 2 }}
          >
            {loading && <CircularProgress color="primary" />}
            {loading ? "" : "Change Now"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={selectedToCode.length > 0}
        onClose={() => resetCode()}
        fullWidth
        maxWidth={"sm"}
      >
        <DialogTitle> Change Code to</DialogTitle>
        <DialogContent>
          <Grid container direction="row" spacing={2} sx={{ pt: 4 }}>
            <Grid item xs={12} xl={12}>
              <EasyTextEdit
                label="Content Code"
                placeholder="Unique content code"
                type="text"
                id="code"
                errorText=""
                textField={true}
                disabled={loading}
                value={code}
                onChange={(value) => setCode(value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ pb: 4 }}>
          <Button onClick={() => resetCode()}>Cancel</Button>
          <Button
            disabled={code === null}
            onClick={() =>
              sendPatchRequest(
                `contents/change-code`,
                { code, uuid: selectedToCode[0] },
                (loading) => onLoading(true),
                (data) => {
                  resetCode();
                  executeFetch();
                  onLoading(false);
                },
              )
            }
            sx={{ mr: 3, pl: 2, pr: 2 }}
          >
            {loading && <CircularProgress color="primary" />}
            {loading ? "" : "Change Now"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={importDialogOpen}
        onClose={() => hideImportDialog()}
        fullWidth
        maxWidth={"md"}
      >
        <DialogTitle> Import from Excel</DialogTitle>
        <DialogContent>
          <Grid container direction="row" spacing={2} sx={{ pt: 4 }}>
            <Grid item xs={12} xl={12}>
              <Dropzone
                onChange={(selectedFiles) => setFiles(selectedFiles)}
                value={files}
                minHeight="150px"
                maxFiles={1}
                accept={".xlsx,.xls"}
                maxFileSize={1024 * 1024 * 20}
                label="Drag'n drop excel file here or click to browse"
              >
                {files.map((file) => (
                  <FileMosaic
                    {...file}
                    resultOnTooltip
                    alwaysActive
                    preview
                    info
                    onDelete={(id) =>
                      setFiles(files.filter((_file) => _file.id !== id))
                    }
                  />
                ))}
              </Dropzone>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ pb: 4 }}>
          <Button onClick={() => hideImportDialog()}>Cancel</Button>
          <Button
            disabled={files.length === 0}
            onClick={() => {
              const formData = new FormData();
              files.forEach((file) => formData.append("files", file.file));
              sendPostRequest(
                `export-import`,
                formData,
                (_) => onLoading(true),
                ({ message, processed }) => {
                  hideImportDialog();
                  showSnack(message);
                  if (processed > 0) {
                    executeFetch();
                  } else onLoading(false);
                },
              );
            }}
            sx={{ mr: 3, pl: 2, pr: 2 }}
          >
            {loading && <CircularProgress color="primary" />}
            {loading ? "" : "Import Now"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showFileSourceTypeDialog} fullWidth maxWidth={"sm"}>
        <DialogTitle sx={{ pt: 4 }}> Manage content file sources </DialogTitle>
        <DialogContent>
          <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item md={5} xs={12}>
                <EasyTextEdit
                  label="File source title"
                  placeholder="i.e Clean from production"
                  type="text"
                  id="title"
                  errorText=""
                  textField={true}
                  disabled={loading}
                  value={fileSource.title}
                  onChange={onValueChange}
                />
              </Grid>

              <Grid item md={3} xs={12}>
                <EasyTextEdit
                  label="Label"
                  placeholder="i.e clean"
                  type="text"
                  id="label"
                  errorText=""
                  textField={true}
                  disabled={loading}
                  value={fileSource.label}
                  onChange={onValueChange}
                />
              </Grid>

              <Grid item md={4} xs={12}>
                <Button
                  className={appStyle.actionButon}
                  sx={{ mt: 1 }}
                  disabled={loading || !fileSource.title || !fileSource.label}
                  variant="contained"
                  onClick={() => createUpdateFileSource()}
                >
                  {fileSource.uuid
                    ? "Update File Source"
                    : "Create File Source"}
                </Button>
              </Grid>

              <Grid item md={12} xs={12}>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 250 }} aria-label="source table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Title</TableCell>
                        <TableCell align="right">Label</TableCell>
                        <TableCell align="right"></TableCell>
                        <TableCell align="right"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {fileSourceTypes
                        .filter((row) => !deletedfileSourceTypes.includes(row.uuid))
                        .map((row) => (
                          <TableRow
                            key={row.uuid}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {row.title}
                            </TableCell>
                            <TableCell align="right">{row.label}</TableCell>
                            <TableCell align="right">
                              <IconButton
                                onClick={() => {
                                  setFileSource(row);
                                }}
                              >
                                <Icon children={"edit"} />
                              </IconButton>
                              <IconButton
                                sx={{ ml: 3 }}
                                variant="contained"
                                onClick={() =>
                                  setDeletedfileSourceTypes([
                                    ...deletedfileSourceTypes,
                                    row.uuid,
                                  ])
                                }
                              >
                                <Icon children={"delete"} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ pb: 4, pr: 4 }}>
          <Button onClick={() => setShowFileSourceTypeDialog(false)}>Dismiss</Button>
          {deletedfileSourceTypes.length > 0 && (
            <Button onClick={() => saveFileSourceChanges()}>
              Save Changes
            </Button>
          )}

          {deletedfileSourceTypes.length > 0 && (
            <Button onClick={() => setDeletedfileSourceTypes([])}>
              Undo Changes
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ContentList;
